module.exports = __webpack_public_path__ + "media/images/parallax/illustration-be-foreground-b933922510f8b02547f8ad5581751972.png";